export default __webpack_public_path__ + "static/media/exterior_map_image.28eeb9a5.png";